import * as e from "react";
const c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MP_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MP_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h34v24H0V0z",
      fill: "#2993EC"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.213 11.583c0 5.293 4.382 9.584 9.787 9.584 5.405 0 9.787-4.29 9.787-9.584C25.787 6.291 21.406 2 16 2c-5.405 0-9.787 4.29-9.787 9.583zm17.446 0c0 4.142-3.43 7.5-7.66 7.5s-7.66-3.358-7.66-7.5c0-4.142 3.43-7.5 7.66-7.5s7.66 3.358 7.66 7.5z",
      fill: "#F1F9FF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.064 11.583c0 4.833 4.001 8.75 8.937 8.75 4.935 0 8.936-3.917 8.936-8.75 0-4.832-4.001-8.75-8.936-8.75-4.936 0-8.937 3.918-8.937 8.75zm17.448 0c0 4.603-3.81 8.334-8.511 8.334-4.7 0-8.51-3.731-8.51-8.334C7.49 6.981 11.3 3.25 16 3.25c4.7 0 8.51 3.731 8.51 8.333z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.001 2.208c-.108.223-.162.54-.162.95 0 .41-.159.82-.476 1.231a9.603 9.603 0 01-.089-1.232c0-.368.242-.685.727-.949zm2.235.338c-.155.193-.279.49-.37.889-.093.4-.34.764-.742 1.093a9.59 9.59 0 01.19-1.22c.084-.36.39-.613.922-.762zm1.538 1.622c.187-.366.378-.623.575-.773-.551.016-.91.188-1.078.516a9.605 9.605 0 00-.48 1.138c.47-.222.797-.516.983-.881zm2.418.516c-.226.101-.47.309-.734.623-.263.314-.65.527-1.157.637.246-.384.487-.718.724-1 .237-.282.626-.37 1.167-.26zm.637 2.112c.327-.247.613-.394.855-.442-.502-.228-.9-.231-1.195-.01a9.598 9.598 0 00-.93.813c.519.006.942-.114 1.27-.361zm1.919 1.54c-.248-.012-.56.062-.937.222-.378.16-.818.174-1.32.043.393-.231.76-.42 1.099-.563.34-.144.725-.045 1.158.298zm-.395 2.155c.404-.072.725-.073.963-.006-.344-.431-.698-.615-1.06-.55a9.6 9.6 0 00-1.198.3c.46.242.892.327 1.296.256zM6.085 9.77c.2.145.503.253.907.324.404.071.78.299 1.13.683a9.594 9.594 0 01-1.228-.127c-.363-.064-.633-.357-.809-.88zm1.539-1.583c-.378-.16-.648-.334-.81-.52.053.55.25.896.589 1.04.34.144.729.277 1.168.4-.254-.453-.57-.76-.947-.92zm.405-2.414c.113.22.333.454.66.7.328.247.56.621.698 1.122a9.603 9.603 0 01-1.037-.67c-.295-.222-.402-.606-.321-1.152zm2.098-.725c-.264-.315-.426-.592-.486-.832-.202.514-.184.912.053 1.195.237.282.524.578.86.886-.021-.519-.164-.935-.427-1.25zm1.448-1.982c.005.247.1.553.287.919.186.365.231.803.134 1.314a9.605 9.605 0 01-.637-1.058c-.168-.328-.096-.72.216-1.175zm2.228.279c-.092-.4-.111-.72-.056-.962-.413.367-.578.73-.495 1.089.083.359.204.752.364 1.18.217-.472.28-.908.187-1.307z",
      fill: "#FDDA33"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.586 5.75a.575.575 0 00-.561.697l.387 1.768a.574.574 0 00.256.364.573.573 0 00-.218.386L13.063 20.61a.531.531 0 00.257.53c.522.299 1.654.86 2.786.86 1.132 0 2.265-.561 2.787-.86a.53.53 0 00.257-.53L17.762 8.965a.573.573 0 00-.217-.386.574.574 0 00.256-.364l.387-1.768a.574.574 0 00-.561-.697h-3.04z",
      fill: "#A7A7A7"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.52 12.013a.32.32 0 01.398-.207c.169.05.263.225.212.39-.09.286-.09.707.01 1.26.037.21.082.374.137.519.022.057.045.11.075.175l.079.17c.095.215.137.404.137.682a.316.316 0 01-.319.312.316.316 0 01-.319-.312.94.94 0 00-.085-.434 13.25 13.25 0 00-.074-.159 3.206 3.206 0 01-.092-.215 3.414 3.414 0 01-.169-.631c-.114-.64-.114-1.155.01-1.55z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.213 16.179l-4.115 2.803 1.452-4.698-3.995-2.965 5.012-.1 1.646-4.636 1.646 4.636 5.011.1-3.994 2.965 1.451 4.698-4.114-2.803z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.559 12.43a.32.32 0 00-.399-.208.311.311 0 00-.212.39c.09.286.09.707-.009 1.26a2.8 2.8 0 01-.138.518 2.61 2.61 0 01-.075.176l-.079.17a1.547 1.547 0 00-.137.682c0 .172.143.312.319.312.176 0 .32-.14.32-.312a.94.94 0 01.084-.434l.074-.159a3.21 3.21 0 00.092-.215c.07-.181.124-.382.169-.631.114-.64.114-1.155-.01-1.55z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.06 3.147s1.165.52.662 1.336M16.912 3.147s1.165.52.662 1.336",
      stroke: "#73BE4A",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.26 6.357a.274.274 0 01.396-.098.33.33 0 01.09.43c-.161.281-.246.666-.246 1.159 0 .173-.128.312-.287.312-.159 0-.287-.14-.287-.312 0-.603.109-1.101.334-1.49z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.809 9.213c0 .172-.129.312-.287.312-.159 0-.288-.14-.288-.312v-.89c0-.63.1-1.126.307-1.489a.274.274 0 01.396-.099.329.329 0 01.091.43c-.142.25-.22.635-.22 1.157v.89zM23.484 8.796c0 .172.129.312.287.312.159 0 .288-.14.288-.312v-.89c0-.63-.1-1.126-.308-1.489a.274.274 0 00-.395-.099.329.329 0 00-.091.43c.142.25.22.635.22 1.157v.89z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.336 10.255c0 .172.128.312.287.312.159 0 .287-.14.287-.312v-.89c0-.63-.099-1.126-.307-1.489a.274.274 0 00-.396-.099.329.329 0 00-.091.43c.143.25.22.635.22 1.157v.89z",
      fill: "#73BE4A"
    }
  ))
), a = c;
export {
  a as default
};
